import request from '@/lib/request'


/***
 * 查询违约订单
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryBreachOrder(params = {}) {
  return request.get(`/api/v1/rental/breach/processing`, params);
}

/***
 * 违约试算
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryBreachTrial(params = {}) {
  return request.post(`/api/v1/rental/breach/trial`, params);
}

/***
 * 申请违约
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function applyBreach(params = {}) {
  return request.post(`/api/v1/rental/breach`, params);
}


/***
 * 违约支付
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function payBreach(params = {}) {
  return request.put(`/api/v1/rental/breach/${params.breachOrderId}/pay`, {
    returnUrl: params.returnUrl,
    payChannel: params.payChannel || '',
  });
}

/***
 * 违约订单填写物流信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function expressBreach(params = {}) {
  return request.put(`/api/v1/rental/breach/${params.breachOrderId}/tracking`, {
    trackingNo: params.trackingNo,
    trackingCompanyKey: params.trackingCompanyKey,
  });
}
